var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M23.037,0.391 L14.716,2.519 L8.708,2.519 L8.708,-0.000 L-0.000,-0.000 L-0.000,30.000 L16.949,30.000 L16.949,12.577 L21.372,29.960 L30.000,27.753 L23.037,0.391 ZM6.370,27.656 L2.338,27.656 L2.338,25.312 L6.370,25.312 L6.370,27.656 ZM6.370,22.969 L2.338,22.969 L2.338,7.031 L6.370,7.031 L6.370,22.969 ZM6.370,4.687 L2.338,4.687 L2.338,2.344 L6.370,2.344 L6.370,4.687 ZM14.611,27.656 L8.708,27.656 L8.708,25.312 L14.611,25.312 L14.611,27.656 ZM14.611,22.969 L8.708,22.969 L8.708,9.551 L14.611,9.551 L14.611,22.969 ZM14.611,7.207 L8.708,7.207 L8.708,4.863 L14.611,4.863 L14.611,7.207 ZM17.252,4.290 L21.350,3.242 L21.908,5.436 L17.810,6.484 L17.252,4.290 ZM18.388,8.755 L22.486,7.707 L26.019,21.589 L21.921,22.637 L18.388,8.755 ZM22.499,24.908 L26.597,23.860 L27.157,26.062 L23.059,27.110 L22.499,24.908 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentations);
export default __webpack_public_path__ + "static/media/documentations.153b82dd.svg";
export { ForwardRef as ReactComponent };